module.exports = __webpack_public_path__ + "img/opensea.119c2c5c.svg";